import React from 'react';
import { Modal, Table, Typography } from 'antd';

const { Text, Paragraph } = Typography;

export interface EpcWbsLibraryShortcutsModalProps {
  open: boolean;
  onClose: () => void;
}

const SHORTCUTS = [
  { keys: '↑ / ↓', action: 'Navigate WBS tree nodes' },
  { keys: '← / →', action: 'Collapse / expand tree branch' },
  { keys: 'Home / End', action: 'First / last visible node' },
  { keys: 'E', action: 'Edit selected WBS node' },
  { keys: 'Delete', action: 'Remove selected WBS node' },
  { keys: 'Esc', action: 'Exit focus mode' },
  { keys: '?', action: 'Show this shortcuts panel' },
];

export const EpcWbsLibraryShortcutsModal: React.FC<EpcWbsLibraryShortcutsModalProps> = ({
  open,
  onClose,
}) => (
  <Modal title="Keyboard shortcuts" open={open} onCancel={onClose} footer={null} width={480}>
    <Paragraph type="secondary">
      Click the WBS tree panel first so it has focus, then use these keys.
    </Paragraph>
    <Table
      size="small"
      pagination={false}
      rowKey="keys"
      dataSource={SHORTCUTS}
      columns={[
        {
          title: 'Keys',
          dataIndex: 'keys',
          width: 120,
          render: (v) => <Text code>{v}</Text>,
        },
        { title: 'Action', dataIndex: 'action' },
      ]}
    />
  </Modal>
);
